export const GLOBAL_STATE = 'ModuleRegistration'

export const MODULE_REGISTRATION = 'MODULE_REGISTRATION' as const
export const MODULE_REGISTRATION_LIST = 'MODULE_REGISTRATION_LIST' as const
export const MODULE_REGISTRATION_CREATE = 'MODULE_REGISTRATION_CREATE' as const
export const MODULE_REGISTRATION_DELETE = 'MODULE_REGISTRATION_DELETE' as const
export const MODULE_REGISTRATION_ALL = 'MODULE_REGISTRATION_ALL' as const
export const MODULE_REGISTRATION_BATCH = 'MODULE_REGISTRATION_BATCH' as const
export const MODULE_REGISTRATION_REGISTER = 'MODULE_REGISTRATION_REGISTER' as const
